/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import { Apps, CloudDownload } from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Gallery"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/diane" className={classes.dropdownLink}>
              Diane Eide 
            </Link>,
            <Link to="/donbendel" className={classes.dropdownLink}>
              Don Bendel
            </Link>,
            <Link to="/donreitz" className={classes.dropdownLink}>
            Don Reitz
            </Link>,
           <Link to="/yamamoto" className={classes.dropdownLink}>
           Yukio Yamamoto
          </Link>,
          <Link to="/vernefunk" className={classes.dropdownLink}>
            Verne Funk
          </Link>, 
          <Link to="/contact" className={classes.dropdownLink}>
           Contact
         </Link>             
          ]}
        />
      </ListItem>
      {/* <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="About"
          buttonProps={{
            className: classes.navLink,
            color: "transparent"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/contact" className={classes.dropdownLink}>
              Eide Fine Art
            </Link>
          ]}
        />
        </ListItem> */ } 
    </List>
  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx